import { assert } from "../asserts/index.ts";
import type { GetNewId } from "./shared.ts";

export interface MakeNodeLookupOptions {
  getNextId: GetNewId;
  fromToIdPairs?: [number, number][];
}

export const nodeImportLookup = ({ getNextId, fromToIdPairs }: MakeNodeLookupOptions) => {
  const nodeIdToNewNodeIdMap = new Map<number, number>(fromToIdPairs);

  const getNewNodeId = (originalId: number) => {
    const nodeId = nodeIdToNewNodeIdMap.get(originalId);
    assert(nodeId, `No new node id for ${originalId}.`);
    return nodeId;
  };

  const hasNewNodeId = (originalId: number) => nodeIdToNewNodeIdMap.has(originalId);

  const addNewNodeId = (originalId: number, newId?: number) =>
    nodeIdToNewNodeIdMap.set(originalId, newId ?? getNextId());

  return { getNewNodeId, hasNewNodeId, addNewNodeId };
};

export type NodeImportLookup = Readonly<ReturnType<typeof nodeImportLookup>>;
